import { push } from 'connected-react-router';
import { APIAuth } from 'lib/api/firebase/apis/api-auth';
import { postSetPassword } from 'lib/api/firebase/apis/apis';
import { ConnectRouterState } from 'lib/store/rootReducer';
import { AppThunk } from 'lib/store/store';
import { resolveError } from 'lib/utils/formatters/error/resolve-error';
import { AuthSliceActions } from './authSlice';
import { auth } from 'lib/api/firebase';
import { useMutation } from '@tanstack/react-query';

export const setUserPassword =
  (password: string): AppThunk =>
  async dispatch => {
    dispatch(AuthSliceActions.startLoadingAction());
    try {
      const result = await APIAuth.updatePassword({ password });
      await postSetPassword();

      await auth.signInWithCustomToken(result.data.signInToken);
      dispatch(
        push<ConnectRouterState>({
          pathname: '/',
          state: {
            lastAction: 'resetPassword'
          }
        })
      );
    } catch (error) {
      console.error('[setUserPassword]', error);
      dispatch(AuthSliceActions.setError(resolveError(error).message));
    } finally {
      dispatch(AuthSliceActions.stopLoadingAction());
    }
  };

export function useUpdatePassword() {
  return useMutation({
    mutationFn: APIAuth.updatePassword,
    async onSuccess(result) {
      await auth.signInWithCustomToken(result.data.signInToken);
    }
  });
}
